import { Resource } from "src/app/core/jsonapi/resource";
import { prop, required } from "@rxweb/reactive-form-validators";
import { WorkerSeizure } from "./worker-seizure";

export class WorkerSeizureAmmount extends Resource {
    public override type = 'workerSeizureAmmounts';

    
    @prop()
    public workerSeizureId!: string;

    public workerSeizure!: WorkerSeizure;
    
    @prop()
    public date: Date = new Date();

    @prop()
    public ammount?: number;

}